React       = require 'react'
DeviceStore = require '../scripts/device_store'

module.exports = CustomDevice = React.createClass
  getInitialState: ->
      width:  ''
      height: ''

  handleSubmit: (e) ->
    e.preventDefault()
    DeviceStore.update
      name:     'Custom device'
      id:       @props.id
      width:    parseInt(@state.width)
      height:   parseInt(@state.height)
      rotation: true

  handleChange: (e) ->
    newstate = {}
    newstate[e.target.name] = e.target.value
    @setState newstate

  render: ->
    React.createElement("form", {"className": "custom-screen", "onSubmit": (@handleSubmit)},
      React.createElement("div", {"className": "custom-screen__title"}, "Custom screen size"),
      React.createElement("input", {"className": "text-input text-input--small custom-screen__text-input", "min": "0", "name": "width", "onChange": (@handleChange), "placeholder": "w", "required": true, "type": "number", "value": (@state.width)}),
      React.createElement("div", {"className": "custom-screen__sign"}, "×"),
      React.createElement("input", {"className": "text-input text-input--small custom-screen__text-input", "min": "0", "name": "height", "onChange": (@handleChange), "placeholder": "h", "required": true, "type": "number", "value": (@state.height)}),
      React.createElement("button", {"className": "button button--small button--primary custom-screen__button"}, "Add")
    )



// WEBPACK FOOTER //
// ./~/cjsx-loader!./app/js/components/custom_device.cjsx